import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Instagram, Linkedin, Mail } from 'lucide-react';
import { Link } from 'react-router-dom';
import { useLanguage } from '../components/LanguageContext';
import { translations } from '../translations';
export function Contact() {
  const [expandedSection, setExpandedSection] = useState<string | null>(null);
  const {
    language
  } = useLanguage();
  const t = translations.contact[language];
  const toggleSection = (section: string) => {
    if (expandedSection === section) {
      setExpandedSection(null);
    } else {
      setExpandedSection(section);
    }
  };
  return <AnimatePresence mode="wait" data-id="element-86" data-mp="17rtlj2uwn35h">
      <motion.div key={language} initial={{
      opacity: 0
    }} animate={{
      opacity: 1
    }} exit={{
      opacity: 0
    }} transition={{
      duration: 0.5
    }} className="w-full" data-id="element-87" data-mp="13022rehzq1pw">
        <div className="split-screen-container" data-id="element-88" data-mp="15ff3lvimw764">
          {/* Left Image Side */}
          <div className="split-screen-left hidden md:block" data-id="element-89" data-mp="15dceret7wk2z">
            <div className="absolute inset-0 bg-cover bg-center bg-no-repeat" style={{
            backgroundImage: 'url("https://images.unsplash.com/photo-1600210492486-724fe5c67fb0?w=1200&q=80")',
            filter: 'brightness(0.7) contrast(1.1)'
          }} data-id="element-90" data-mp="19fz2p4mrpkuw" />
          </div>

          {/* Right Content Side */}
          <div className="split-screen-right bg-dark pt-32 pb-24" data-id="element-91" data-mp="qj7kkyiypbsf">
            <div className="w-full max-w-md mx-auto flex flex-col h-full" data-id="element-92" data-mp="vh96dr7rvp7l">
              <motion.div initial={{
              opacity: 0,
              y: 20
            }} animate={{
              opacity: 1,
              y: 0
            }} transition={{
              duration: 0.8
            }} data-id="element-93" data-mp="vjc3swb98kmc">
                <h1 className="text-4xl md:text-5xl font-cinzel text-cream mb-16 text-center" data-id="element-94" data-mp="1m73k5ltz5083">
                  {t.title}
                </h1>
              </motion.div>

              {/* Session Types (Pill Buttons) */}
              <div className="space-y-4 mb-20 flex-grow" data-id="element-95" data-mp="1w5t55nh630sk">
                {/* Cabinet */}
                <motion.div initial={{
                opacity: 0,
                x: 20
              }} animate={{
                opacity: 1,
                x: 0
              }} transition={{
                duration: 0.6,
                delay: 0.2
              }} data-id="element-96" data-mp="1r5wwhaxiyl6o">
                  <button onClick={() => toggleSection('cabinet')} className="w-full py-4 px-6 rounded-full border-[0.5px] border-white/20 text-cream font-inter tracking-widest uppercase text-sm hover:border-gold/50 transition-colors flex justify-between items-center bg-white/5" data-id="element-97" data-mp="18g8kn05d7vh6">
                    <span data-id="element-98" data-mp="2rdv2or02031o">{t.cabinet}</span>
                    <span className="text-gold" data-id="element-99" data-mp="2w5d2vcu95zll">
                      {expandedSection === 'cabinet' ? '−' : '+'}
                    </span>
                  </button>
                  <AnimatePresence data-id="element-100" data-mp="2hi1pr6ifa7jd">
                    {expandedSection === 'cabinet' && <motion.div initial={{
                    height: 0,
                    opacity: 0
                  }} animate={{
                    height: 'auto',
                    opacity: 1
                  }} exit={{
                    height: 0,
                    opacity: 0
                  }} className="overflow-hidden" data-id="element-101" data-mp="2mg38trfum6uu">
                        <div className="p-6 text-cream/70 font-inter text-sm space-y-4 text-center" data-id="element-102" data-mp="1prnkfyoh63jb">
                          <div data-id="element-103" data-mp="1tojmvzrvaep5">
                            <p className="text-gold mb-1" data-id="element-104" data-mp="29yj2rx2rvabu">
                              {t.locations.vp.name}
                            </p>
                            <p data-id="element-105" data-mp="255zn8ukiy54e">
                              {'Relate Office - Victoria Park Market 19/210 Victoria Street West, Auckland CBD'}
                            </p>
                          </div>
                          <div data-id="element-106" data-mp="2svu0veco3xpp">
                            <p className="text-gold mb-1" data-id="element-107" data-mp="2sw3nqt2f1or6">
                              {t.locations.epsom.name}
                            </p>
                            <p data-id="element-108" data-mp="2iy61uc81441q">
                              {'Alpers Clinic - 24 Manukau Road, Epsom Auckland 1023'}
                            </p>
                          </div>
                        </div>
                      </motion.div>}
                  </AnimatePresence>
                </motion.div>

                {/* Online */}
                <motion.div initial={{
                opacity: 0,
                x: 20
              }} animate={{
                opacity: 1,
                x: 0
              }} transition={{
                duration: 0.6,
                delay: 0.3
              }} data-id="element-109" data-mp="3f6lkspv9kyqq">
                  <Link to="/booking" className="block" data-id="element-110" data-mp="1r745xa118vd">
                    <button className="w-full py-4 px-6 rounded-full border-[0.5px] border-white/20 text-cream font-inter tracking-widest uppercase text-sm hover:border-gold/50 transition-colors flex justify-center items-center bg-white/5" data-id="element-111" data-mp="1sqk1mrrthwm">
                      <span data-id="element-112" data-mp="fqf44se0kl0m">{t.online}</span>
                    </button>
                  </Link>
                </motion.div>

                {/* Home */}
                <motion.div initial={{
                opacity: 0,
                x: 20
              }} animate={{
                opacity: 1,
                x: 0
              }} transition={{
                duration: 0.6,
                delay: 0.4
              }} data-id="element-113" data-mp="2cktjlc79ja4t">
                  <button className="w-full py-4 px-6 rounded-full border-[0.5px] border-white/20 text-cream font-inter tracking-widest uppercase text-sm hover:border-gold/50 transition-colors flex justify-center items-center bg-white/5" data-id="element-114" data-mp="3tufayk7urpp5">
                    <span data-id="element-115" data-mp="2ncmi0jefxim">{t.home}</span>
                  </button>
                </motion.div>
              </div>

              {/* Contact Info */}
              <motion.div initial={{
              opacity: 0,
              y: 20
            }} animate={{
              opacity: 1,
              y: 0
            }} transition={{
              duration: 0.8,
              delay: 0.6
            }} className="text-center mt-auto" data-id="element-116" data-mp="gdg2wavlkx05">
                <a href="https://wa.me/64211538500?text=Hi%20Juliette,%20I%20would%20like%20to%20book%20a%20session%20with%20you." target="_blank" rel="noopener noreferrer" className="block text-3xl font-cinzel text-gold mb-12 transition-all duration-300 hover:text-[#d4b87a] hover:drop-shadow-[0_0_8px_rgba(184,154,111,0.5)]" data-id="element-117" data-mp="14zvte4f7b71v">
                  +64 21 153 8500
                </a>

                {/* Socials */}
                <div className="flex justify-center space-x-8" data-id="element-118" data-mp="r1fpsmcmxwny">
                  <a href="https://www.instagram.com/therapy.nz/" target="_blank" rel="noopener noreferrer" className="text-rose hover:text-gold transition-colors" data-id="element-119" data-mp="cbhw5qvxserd">
                    <Instagram size={24} strokeWidth={1.5} data-id="element-120" data-mp="7b40777m0v9p" />
                  </a>
                  <a href="https://www.linkedin.com/in/juliette-cazabat-b2504b3a3/" target="_blank" rel="noopener noreferrer" className="text-rose hover:text-gold transition-colors" data-id="element-121" data-mp="7d6lxf1qc28m">
                    <Linkedin size={24} strokeWidth={1.5} data-id="element-122" data-mp="durxqcy33f5z" />
                  </a>
                  <a href="mailto:juliettecazabat.nz@gmail.com?subject=Session%20Inquiry%20-%20Juliette%20Cazabat&body=Hi%20Juliette,%20I%20would%20like%20to%20enquire%20about%20a%20session..." className="text-rose hover:text-gold transition-colors" data-id="element-123" data-mp="8t2jkofkeldo">
                    <Mail size={24} strokeWidth={1.5} data-id="element-124" data-mp="3r7uylt0y6c40" />
                  </a>
                </div>
              </motion.div>
            </div>
          </div>
        </div>
      </motion.div>
    </AnimatePresence>;
}